import "./general.scss";
import * as React from "react";
import { FeatureFlags } from '../../../../services/featureflag/featureflags';
import { isFeatureFlagEnable } from '../../../../services/featureflag/featureflagservice';
import { IN_PROGRESS, READY_TO_EDIT, PROFILE, CDS } from '../../../../constants/status';
import { Context, ADMIN_ROLE } from '../../ModulePage/exportfiles';
import Card from '../../../../components/Card/Card';
import { OrgInfo } from '../../../../components/OrgInfo/OrgInfo';
import noteTaking from '../../../../assets/images/noteTaking.png';
import image from '../../../../assets/images/emWelcome.jpg';
import { dateAndTimeFormatter, getRefValue, openWindow } from "../../../../utils/utils";
import { lastUpdateTitle, lastUpdateDesc, referenceDesc, referenceTitle, welcomeDescription, emailContactUs, emailCDS, supportSiteLabel } from "../../../../constants/welcome";
import { DEFAULT_LINK, STUDENTS_COUNT, SUPPORT_SITE_LINK } from "../../../../constants/references";
import { WelcomeReference } from "../../../../components/Welcome/welcomeReferences";
//filter only READY TO EDIT and IN PROGRESS modules
const inProgressCategoryFilter = (category) => category.status?.toUpperCase() === IN_PROGRESS || category.status?.toUpperCase() === READY_TO_EDIT;

const WelcomePage = ({ org_rol_s, org_id, setNavSelection, setSelApiAttribute, setCategoryName, dataCollectionTypes }) => {

  const { getCdsCategory, downloadFullPDF, findorganswersbyorgidlasthed, state: { orgData, reminderData } } = React.useContext(Context);
  const [showViewProfileFlag, setShowViewProfileFlag] = React.useState(false);
  const [showUploadCDSFlag, setShowUploadCDSFlag] = React.useState(false);
  const [showDownloadAllFlag, setDownloadAllFlag] = React.useState(false);
  const [latestProfileData, setLatestProfileData] = React.useState(lastUpdateDesc);
  const orgName = orgData?.find(el=> parseInt(el.org_id) === parseInt(org_id))?.org_name;
  const [studentsCount, setStudentsCount] = React.useState(referenceTitle);
  const [userGuideLink, setUserGuideLink] = React.useState(DEFAULT_LINK);

  const profileDataFormatter = (data) => {
      return data ? `by ${data?.last_updated_by} ${dateAndTimeFormatter(data?.last_updated_at)}` : `by -- --`;
  };

  React.useEffect(() => {
    let mounted = true;
    const onLoad = async () => {

      const latestUpdate = await findorganswersbyorgidlasthed(org_id);
      if(mounted){
        // const editableQuestions = results.data.data.filter(inProgressCategoryFilter); CDS
        const viewProfileFlag = await isFeatureFlagEnable(FeatureFlags.viewprofile);
        const uploadCDSFlag = await isFeatureFlagEnable(FeatureFlags.uploadcds, true);
        const downloadAllFlag = await isFeatureFlagEnable(FeatureFlags.downloadallbutton);
        setShowViewProfileFlag(viewProfileFlag); //show or hide view profile button
        setShowUploadCDSFlag(uploadCDSFlag); // show or hide upload cds button (being used for Email Completed CDS button)
        setDownloadAllFlag(downloadAllFlag); //show or hide download all button on home page

        //last update logic
        if(latestUpdate?.status === 200 && Object.keys(latestUpdate?.data).length !== 0){
          let data = {};
          if(latestUpdate.data.lastBFCPUser===null){
            data.last_updated_by = 'N/A';
          }
          else{
            data.last_updated_by = latestUpdate.data.lastBFCPUser;
          }

          if(latestUpdate.data.adminBFCPDate===null &&latestUpdate.data.hedBFCPDate===null){
            data.last_updated_at = 'N/A';
          }
          else if(latestUpdate.data.adminBFCPDate===null){
            data.last_updated_at = latestUpdate.data.hedBFCPDate;
          }
          else if(latestUpdate.data.hedBFCPDate===null){
            data.last_updated_at = latestUpdate.data.adminBFCPDate;
          }
          else{
            data.last_updated_at = latestUpdate.data.adminBFCPDate>latestUpdate.data.hedBFCPDate?latestUpdate.data.adminBFCPDate:latestUpdate.data.hedBFCPDate;
          }
          setLatestProfileData(profileDataFormatter(data));
        }


        //student count logic
        const refTitle = getRefValue(reminderData, STUDENTS_COUNT);
        setStudentsCount((refTitle === -1) ? referenceTitle : refTitle);
        setShowViewProfileFlag(viewProfileFlag); //show or hide view profile button
        //user guide link
        const guideLink = getRefValue(reminderData, SUPPORT_SITE_LINK);
        setUserGuideLink((guideLink === -1) ? DEFAULT_LINK : guideLink);
      }
    };
    onLoad();
    return () => {
      mounted = false;
    };
  }, [getCdsCategory, findorganswersbyorgidlasthed, org_id, org_rol_s]);

  const changeSelection = (tobeSelected, toapiAttr, categoryName) => {
    setNavSelection(tobeSelected);
    setSelApiAttribute(toapiAttr);
    setCategoryName(categoryName);
  };

  const onUploadCDSClick = ()=>{
    window.location = emailCDS;
  };

  const hideDL = (dataCollectionTypes&&dataCollectionTypes.length===1&&dataCollectionTypes[0].collection_type==='APCP')
                    ||(dataCollectionTypes&&dataCollectionTypes.length<1)||!dataCollectionTypes;
  
  const onDLPdfClick = async () =>{
    const res = await downloadFullPDF(org_id);
    if(res.data) {
      const file = new Blob([res.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const pdfWindow = window.open();
      pdfWindow.location.href = fileURL; 
    }   
  };

  const onContactUsClick = () => {
    window.location = emailContactUs;
  };

  return(
    <div className="welcome-section">

      <div className="landing-page" style={{marginBottom:'20px'}}>
        <div className="landing-page__content">
          <div className="landing-page__profile-banner cb-paragraph1-res">
              <span className="landing-page__line">
                  Annual Survey of Colleges
              </span>
          </div>
          <div className="landing-page__text">
              {orgName?
                  <div className="landing-page__welcome-message ">Welcome,<br></br>
                      <span className="truncate-text">
                          {orgName}
                      </span>
                  </div>
                  :
                  <div className="landing-page__welcome-message ">Welcome</div>
              }
              <div className="landing-page__description ">{welcomeDescription}</div>
          </div>
        </div>
        <div className="landing-page__image">
          {image && <img src={image} alt="Welcome Image" />}
        </div>
      </div>

      <div className="cards-section">
        <WelcomeReference lastUpdateTitle={lastUpdateTitle}
                latestProfileData={latestProfileData}
                studentsCount={studentsCount}
                referenceDesc={referenceDesc}/>
      </div>

      <div style={{margin:'20px'}}>
        <Card title='Share Your CDS Data'
            description="Leverage your completed Common Data Set (CDS) file by emailing it to the College Board for submission of your Annual Survey of Colleges information."
            //additionalDescription="It's quick and easy to make updates, and in most cases changes will be reflected later the same day!"
            imageSrc={noteTaking}
            imageSrcAlt="student welcome"
            primaryButtonText='Download CDS Form'
            primaryButtonAction={() => openWindow(`https://commondataset.org/`)}
            secondaryButtonText={showUploadCDSFlag ? 'Email Completed CDS' : ''}
            secondaryButtonAction={onUploadCDSClick}
            > 
        </Card>
      </div>

      <div className="main-container">
          

          <Card title='Download Survey'
          illuClass='cb-ilus cb-ilus-download cb-ilus-monotone cb-ilus-circular'
          description="Need a copy of your answers for your records? Download your completed survey for a PDF with all the data you've provided for your institution's profile."
          primaryButtonText={!hideDL&&showDownloadAllFlag?'Download Completed Survey':''}
          primaryButtonAction={!hideDL&&showDownloadAllFlag?() => onDLPdfClick():null} 
          customClass='thirdwidth cardLeft'> 
          </Card>

          <Card title="Have Questions? We're Here to Help"
          illuClass='cb-ilus cb-ilus-chat cb-ilus-monotone cb-ilus-circular'
          description='Reach out with any questions you may have as you provide your Annual Survey of Colleges.'
          primaryButtonText='Contact Us'
          primaryButtonAction={onContactUsClick}
          secondaryButtonText={supportSiteLabel}
          secondaryButtonAction={() => openWindow(userGuideLink)}
          customClass='thirdwidth '> 
          </Card>

          <Card title='BigFuture Profile Management'
          illuClass='cb-ilus cb-ilus-megaphone cb-ilus-monotone cb-ilus-circular'
          description='Designed for regular updates to your profile and media, anytime between annual cycles.'
          primaryButtonText='Visit BFPM'
          primaryButtonAction={() => openWindow(`https://bigfuturemanage.collegeboard.org`)}
          customClass='thirdwidth cardRight italicDescription'
          > 
          </Card>
      </div>

      <div style={{margin:'20px'}}>
        <OrgInfo org_id={org_id}/>
      </div>

    </div>
  );
};

export default WelcomePage;